import PageAnalytics from './PageAnalytics';

export default PageAnalytics;

